import { AutoMap } from "@automapper/classes";

export class PompeDTO {
    @AutoMap()
    reference!: string;
    @AutoMap()
    bluetooth!: boolean;
    @AutoMap()
    electriciteAccessible!: boolean;
    @AutoMap()
    debitInitial!: number;
    @AutoMap()
    debitFinal!: number;
    @AutoMap()
    compteurVolInitial!: number;
    @AutoMap()
    compteurVolFinal!: number;
    @AutoMap()
    compteurHoraireInitial!: number;
    @AutoMap()
    compteurHoraireFinal!: number;

}